import moment, { Moment } from 'moment';
import { FormField, VuetifySelectItem } from '@/application/types';
import { formatTime } from '@/filters/dates';
import { enumerateDates } from '@/helpers/date-helpers';

export function isTextFieldFilled(field: FormField<string>): boolean {
  return field.value.trim().length > 0;
}

export function isTextFilled(value?: string): boolean {
  return value !== undefined && value.trim().length > 0;
}

function generateTimes(startTime: Moment, endTime: Moment, intervalMinutes: number): Moment[] {
  return enumerateDates(startTime, endTime, intervalMinutes, 'minutes')
    .map((dateString) => moment(dateString));
}

export function generateTimesSelectItems(startTime: Moment, endTime: Moment, intervalMinutes: number): VuetifySelectItem<Moment>[] {
  return generateTimes(startTime, endTime, intervalMinutes)
    .map((date) => ({ text: formatTime(date), value: date }));
}

export function generateDefaultTimesForCurrentDaySelectItems(intervalMinutes: number): VuetifySelectItem<Moment>[] {
  const startTime = moment().startOf('day').hours(5);
  const endTime = moment().startOf('day').add(1, 'day');

  return generateTimes(startTime, endTime, intervalMinutes)
    .map((date) => ({ text: formatTime(date), value: date }));
}

export function generateTimeRangeSelectItems(startTime: Moment, endTime: Moment, intervalMinutes: number): VuetifySelectItem<number>[] {
  const date = startTime.clone();
  const selectItems = [];
  let interval = 1;

  do {
    selectItems.push({
      text: `${interval * intervalMinutes} Minuten`,
      value: interval
    });
    interval++;
  } while (date.add(intervalMinutes, 'minutes').diff(endTime) < 0);

  return selectItems;
}
